export default __webpack_public_path__ + "static/media/456dd9a6feb345b3bcf42f6abe6771af.cb089117.png";